class MobileCategoryDrawer extends HTMLElement {
    connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.bindFastAccountNavigation();
        this.tabs = Array.from(this.querySelectorAll('.wp-mobile-rail__tab'));
        this.panels = Array.from(this.querySelectorAll('[data-category-panel]'));
        if (!this.tabs.length || !this.panels.length) return;

        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        const activeIndex = this.tabs.findIndex((tab) => tab.dataset.active === 'true');
        this.select(activeIndex >= 0 ? activeIndex : 0, false);
    }

    bindFastAccountNavigation() {
        const accountLink = this.closest('.wp-mobile-drawer')?.querySelector('[data-drawer-account-link]');
        if (!accountLink) return;

        let routeWarmed = false;
        const warmRoute = () => {
            if (routeWarmed) return;
            routeWarmed = true;
            const prefetch = document.createElement('link');
            prefetch.rel = 'prefetch';
            prefetch.as = 'document';
            prefetch.href = accountLink.href;
            document.head.appendChild(prefetch);
        };

        accountLink.addEventListener('pointerenter', warmRoute, { once: true });
        accountLink.addEventListener('focus', warmRoute, { once: true });
        accountLink.addEventListener('touchstart', warmRoute, { once: true, passive: true });
        accountLink.addEventListener(
            'click',
            (event) => {
                if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
                event.preventDefault();
                event.stopPropagation();
                window.location.assign(accountLink.href);
            },
            { capture: true }
        );
    }

    select(index, moveFocus = false) {
        const safeIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
        this.tabs.forEach((tab, tabIndex) => {
            const selected = tabIndex === safeIndex;
            tab.classList.toggle('is-active', selected);
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
            panel.hidden = panelIndex !== safeIndex;
        });
        this.panels[safeIndex].scrollTop = 0;
        if (moveFocus) this.tabs[safeIndex].focus();
    }

    onKeydown(event, index) {
        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.select(nextIndex, true);
    }
}

if (!customElements.get('mobile-category-drawer')) {
    customElements.define('mobile-category-drawer', MobileCategoryDrawer);
}
